import { render } from "./MessageView.vue?vue&type=template&id=fb27bcd6&scoped=true"
import script from "./MessageView.vue?vue&type=script&lang=js"
export * from "./MessageView.vue?vue&type=script&lang=js"

import "./MessageView.vue?vue&type=style&index=0&id=fb27bcd6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb27bcd6"]])

export default __exports__